import { Xicon } from ".././Images"

export const PaymentCancelModal = ({ popstatus, handleClose , paymentInfo }) => {
  console.log("Payment Info ", paymentInfo);

  return (
    <div className="manage_season_modal payment_cancel_model">
      {popstatus && (
        <div className="managecou-popup">
          <div className="managecou-content">
            <i className="fa-solid fa-xmark" onClick={handleClose} ></i>
            <div className="managecou-contentdiv">
              <img src={Xicon} alt="approveIcon" />
              <h1>Are you Sure?</h1>
              <p>Are you sure you want to reject this payment?</p>
            </div>
            <div className="managecou-btn">
              <button className="btn1" onClick={handleClose}>
                Cancel
              </button>
              <button className="btnApprove2" >
                Reject
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
